import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Modal,
  DatePicker,
  Select,
  Radio,
  InputNumber,
  Slider,
  Checkbox,
  Space,
  Table,
  Tag,
  Spin,
  Switch
} from 'antd'
import {
  CloseCircleOutlined,
  EyeOutlined,
  MailOutlined,
  MessageOutlined,
} from '@ant-design/icons'
import { getPatientListForCompany } from '../../store/action/patient.action'
import _ from 'lodash'
import '../../css/patient.scss'
import { useHistory } from 'react-router'
import util from '../../util/util'
import { constants } from '../../constants'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input/input'
import { loginAsCustomer } from '../../store/action/profile.action'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const { RangePicker } = DatePicker
const { Option } = Select
var form = null

const PatientFilter = (props) => {
  const [open, setOpen] = useState(false)
  var history = useHistory()
  const [spin, setSpin] = useState(false)

  // Opening LOCATE PATIENT starts a FRESH search.
  //
  // It used to repopulate the form from the last search (`props.filters`), so a
  // patient id pasted earlier was still sitting in the box the next time it
  // opened. That is worse than untidy here: this popup exists to resolve ids out
  // of support notifications, and a stale id above a stale result list is an
  // easy way to act on the wrong patient. The results are cleared with the
  // fields for the same reason — a blank form above somebody else's row is the
  // half-state that actually misleads.
  useEffect(() => {
    if (!open) return
    form &&
      form.setFieldsValue({
        patient_id: '',
        phone: '',
        lastdigitsofphone: '',
        lastname_plain: '',
        surgeon: '',
        inactive: false,
      })
    props.fetchPatient({
      filters: {},
      metadata: { pageSize: 20, current: 1 },
      companyid: props.companyid,
      sorter: props.sorter,
    })
  }, [open])

  var onFinish = (data) => {
    form.validateFields().then((data) => {
      setSpin(true)
      var values = _.pickBy(data, _.identity)
      values.lastdigitsofphone &&
        (values.lastdigitsofphone = parseFloat(values.lastdigitsofphone))

      if (values.surgeon) values.surgeon = [values.surgeon.trim()]
      if (values.lastname_plain)
        values.lastname_plain = values.lastname_plain.trim()
      // Ids get pasted out of emails and bring whitespace with them.
      if (values.patient_id) values.patient_id = values.patient_id.trim()

      props
        .fetchPatient(
          {
            filters: values,
            metadata: { pageSize: 20, current: 1 },
            companyid: props.companyid,
            sorter: props.sorter,
          },
          {}
        )
        .then((res) => setSpin(false))
    })
  }

    let patientCase = ({ _id, customer, lastdigitsofphone, firstname, phone, lastname, healthcoach }) => {
        history.push({
            pathname:'/cases-add',
            state: { type: constants.ACTION_CASE_TITLE.PATIENT_TECHNICAL, back: '/cases', patientid: _id, customer, back: '/customers', lastFourDigits: (lastdigitsofphone.toString()), firstname, lastname, phone, HCid:healthcoach }
        })
    }


  const columns = [
    {
      title: 'Clinic',
      dataIndex: 'customer',
      key: 'customer',
      render: (text) => <>{text?.name}</>,
    },
    {
      title: 'Patient Name',
      dataIndex: 'firstname',
      key: 'firstname',
      render: (text, record) => (
        <>{record.firstname + ' ' + record?.lastname}</>
      ),
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      render: (text) => <>{text}</>,
    },
    {
      title: 'Provider',
      dataIndex: 'surgeon',
      key: 'lastname',
      render: (text) => <>{text?.name}</>,
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <EyeOutlined
            style={{ fontSize: '19px' }}
            title='View Patient'
            onClick={() => {
              props.loginAsCustomer({ ...record?.customer })
              history.push({
                pathname: `/patient/${record?._id}`,
              })
            }}
          />
          <MessageOutlined
            style={{ fontSize: '19px' }}
            title='Send message'
            onClick={(e) => {
              e.stopPropagation();
              patientCase(record)
            }}
          />
        </Space>
      ),
    },
  ]
  const data = [
    {
      key: '3',
      name: 'Joe Black',
      age: 32,
      address: 'Sydney No. 1 Lake Park',
      tags: ['cool', 'teacher'],
    },
  ]

  const handleRowClick=(record)=>{
    props.loginAsCustomer({ ...record?.customer })
     history.push({
      pathname: `/patient/${record?._id}`,
      })
  }
  var handleRow = (record, rowIndex) => {
    return {
      onClick: () => handleRowClick(record),
    }
  }
  var renderCard = () => {
    return (
      <>
        <Row justify='end' style={{ width: '100%' }}>
          <Col>
            {' '}
            <CloseCircleOutlined
              style={{ fontSize: '22px', margin: '10px' }}
              onClick={() => setOpen(false)}
            />
          </Col>
        </Row>
        <Card bordered={false}>
          <>
            {' '}
            <Form
              ref={(e) => (form = e)}
              name='normal_login'
              layout='horizontal'
              labelCol={{ span: 7 }}
            >
              {/*
                First, and labelled as an exact match, because it behaves
                differently from every other field here: one result or none, no
                partial matching. Support receives this id in the registration
                and consent notification emails, which no longer carry patient
                names - docs/PLAN_MINIMIZE_PHI_IN_EMAIL.md.
              */}
              <Form.Item
                name='patient_id'
                label='Patient ID'
                extra='Exact match. Paste the ID from a support notification email.'
              >
                <Input placeholder='Enter Patient ID' />
              </Form.Item>
              <Form.Item
                label='Phone'
                name='phone'
                rules={[
                  {
                    required: false,
                    whitespace: true,
                    message: 'Please enter patient cell number.',
                  },
                  () => ({
                    validator(rule, value) {
                      var number = value
                        ? value.charAt(0) == '+'
                          ? value
                          : '+1' + value
                        : ''
                      if (!value || isValidPhoneNumber(number)) {
                        return Promise.resolve()
                      }
                      return Promise.reject('Please enter valid number!')
                    },
                  }),
                ]}
              >
                <PhoneInput
                  addInternationalOption={false}
                  defaultCountry='US'
                  className='phone-input placeholder1'
                  placeholder='Enter Phone'
                  style={{ width: '-webkit-fill-available' }}
                  enableAreaCodes
                />
              </Form.Item>
              <Form.Item
                name='lastdigitsofphone'
                className='fullheight'
                label={
                  <span style={{ whiteSpace: 'normal' }}>
                    Last Four Digit Of Phone
                  </span>
                }
                rules={[
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || value.toString().length == 4) {
                        return Promise.resolve()
                      }
                      return Promise.reject('Please enter 4 digits')
                    },
                  }),
                ]}
              >
                <Input type='tel' placeholder='Enter Phone last 4 digits' />
              </Form.Item>
              <Form.Item
                rules={[
                  { whitespace: true, message: 'Please remove empty spaces.' },
                ]}
                name='lastname_plain'
                label='Last Name'
              >
                <Input type='lastname_plain' placeholder='Enter Last Name' />
              </Form.Item>
              <Form.Item
                rules={[
                  { whitespace: true, message: 'Please remove empty spaces.' },
                ]}
                name='surgeon'
                label='Provider'
              >
                <Input type='surgeon' placeholder='Enter provider Name' />
              </Form.Item>

              <Form.Item name="inactive" label="Show inactive patients" valuePropName="checked">
              <Switch />
            </Form.Item>
            </Form>
          </>

          <Row justify={'end'} gutter={24}>
            <Col className='ant-modal-footer' style={{ padding: '0px' }}>
              <Button
                className={' ant-btn'}
                style={{ marginRight: '0px', border: '1px solid #001529' }}
                onClick={() => {
                  props.fetchPatient({
                    filters: {},
                    metadata: { pageSize: 20, current: 1 },
                    // customerid: props.customer?.map((i) => i._id) || null,
                    companyid: props.companyid,
                    sorter: props.sorter,
                  })
                  form &&
                    form.setFieldsValue({
                      surgeon: '',
                      phone: '',
                      lastname_plain: '',
                      lastdigitsofphone: '',
                      patient_id: '',
                      inactive:false

                    })
                }}
              >
                Clear Filter
              </Button>
            </Col>
            <Col>
              <Button
                className={'actionBtn'}
                justify={'end'}
                onClick={() => {
                  onFinish()
                }}
              >
                Filter
              </Button>
            </Col>
          </Row>
          <Spin spinning={spin}>
            <Row style={{ overflow: 'scroll' }}>
              <Table
                className='locate-patient-table'
                columns={columns}
                style={{ width: '100%' }}
                dataSource={props.patients}
                onRow={handleRow}
              />
            </Row>
          </Spin>
        </Card>
      </>
    )
  }

  return (
    <>
      <Row align={'end'}>
        <Col>
          <Row justify={'end'}>
            <Button
              className={'actionBtn'}
              onClick={() => {
                setOpen(true)
              }}
            >
              LOCATE PATIENT
            </Button>
          </Row>
        </Col>
      </Row>
      <Modal
        className={'filterModal'}
        visible={open}
        closable={false}
        maskClosable={false}
        width={'50%'}
        okText={'Filter'}
        onOk={onFinish}
        onCancel={() => setOpen(false)}
        footer={[
          <Button
            key='cancel'
            onClick={() => setOpen(false)}
            style={{ marginRight: 'auto' }}
          >
            Cancel
          </Button>,
        ]}
      >
        {renderCard()}
      </Modal>
    </>
  )
}

PatientFilter.propTypes = {
  fetchPatient: PropTypes.func.isRequired,
  customer: PropTypes.object,
  metadata: PropTypes.object,
  patients: PropTypes.array,
  surgeons: PropTypes.array,
  filters: PropTypes.object,
  sorter: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    customer: state.customer.customers,
    defaultFilter: state.profile.user.filter,
    metadata: state.patient.metadata,
    filters: state.patient.companyPatientFilter,
    patients: state.patient.companyPatients,
    surgeons: state.surgeon.surgeons,
    sorter: state.patient.sorter,
    decoded: util.verifyToken(state.profile.token, true),
    user: state.profile?.user,
    companyid: state.profile.company._id,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPatient: (params, patients) =>
      dispatch(getPatientListForCompany(params, patients)),
    loginAsCustomer: (params) => dispatch(loginAsCustomer(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientFilter)
